module.exports = __webpack_public_path__ + "static/GreycliffCF-Bold-10a85831ffaa38bcdb444217c664845a.ttf";